// Todo: I change all the page with new design and fixed the map 
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { BeatLoader } from "react-spinners";
import ChangeType from "../Components/ChangeType";
import Footer from "../Components/Footer";
import logo from "../Images/Login/logo.svg";
import logoRemoved from "../Images/logo-removed.png";
import "swiper/css";
import "swiper/css/navigation";
import "../Styles/FromBranch.css";

// Custom marker icon
const customIcon = new L.Icon({
  iconUrl: logoRemoved,
  iconSize: [70, 70],
  iconAnchor: [20, 41],
  popupAnchor: [15, -40],
});

function FromBranch(props) {
  const { t, i18n } = useTranslation();
  const [branch, setBranch] = useState(JSON.parse(localStorage.getItem("nearBranches")) || []);
  const [changeModal, setChangeModal] = useState(false);
  const [title, setTitle] = useState("home.option-branch");
  const [loading, setLoading] = useState(true);
  const [position, setPosition] = useState({ lat: 24.7136, lng: 46.6753 }); // Default to Riyadh
  const history = useNavigate();

  useEffect(() => {
    console.log("props:", props)
    window.scrollTo(0, 0);
    if (localStorage.getItem("typeId") == 2) {
      setTitle("home.option-home");
    }
    
    if (branch.length > 0) {
      setPosition({
        lat: parseFloat(branch[0]?.latitude) || 24.7136,
        lng: parseFloat(branch[0]?.longitude) || 46.6753,
      });
    }
    
    setLoading(false);
  }, []);

  function chooseBranch(id) {
    const token = localStorage.getItem("token");
    let branchId = localStorage.getItem("branchId");

    if (token && props.cartItems !== 0 && branchId && branchId !== id) {
      setChangeModal(true);
    } else {
      localStorage.setItem("branchId", id);
      history("/menu");
    }
  }

  function handleClear() {
    // Implement clear cart logic here
  }

  function handleBranchesId(id) {
    chooseBranch(id)
    localStorage.setItem("orderBranch", id);
  }

  if (loading) {
    return (
      <div className="loader">
        <BeatLoader color={"#ffc010"} loading={loading} size={30} />
      </div>
    );
  }

  return (
    <div>
      {changeModal && (
        <ChangeType
          text="change_branch"
          handleClear={handleClear}
          setModal={setChangeModal}
        />
      )}
      <div className="Address">
        <div className="addressNav branchesPick container-fluid fluid">
          <p>
            <Link to="/"> {t("address.home")} </Link>
            {i18n.language == "ar" ? (
              <IoIosArrowBack style={{ color: "#4F4F4F" }} />
            ) : (
              <IoIosArrowForward style={{ color: "#4F4F4F" }} />
            )}
            <span> {t(title)} </span>
          </p>
        </div>
        <div className="mapMargin">
          <MapContainer 
            center={[position.lat, position.lng]} 
            zoom={13} 
            style={{ height: '400px', width: '100%' }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            {branch.map((data, index) => (
              <Marker 
                key={index} 
                position={[parseFloat(data.latitude), parseFloat(data.longitude)]} 
                icon={customIcon}
              >
                <Popup className="map-popup">
                  <div >
                    <h3>{data.name}</h3>
                    <p>{data.address}</p>
                    <span style={data.is_active? {color: "#0dbf0d"} : {color: "red"}}>{data.is_active ? t("branches.open") : t("branches.Closed")}</span>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
          <div className="branchesSlider">
            <div className="verticalAlign">
              {branch.length !== 0 && (
                <Swiper
                  navigation={true}
                  dir={i18n.language == "ar" ? "rtl" : "ltr"}
                  spaceBetween={10}
                  key={i18n.language}
                  breakpoints={{
                    530: { slidesPerView: 1, spaceBetween: 20 },
                    730: { slidesPerView: 2, spaceBetween: 20 },
                    1160: { slidesPerView: 3, spaceBetween: 20 },
                  }}
                  modules={[Navigation]}
                  className={i18n.language == "ar" ? "myCarousel branchesCrsl btnAr" : "myCarousel branchesCrsl btnEn"}
                >
                  {branch.map((data, index) => (
                    <SwiperSlide key={index}>
                      <div style={{ margin: "0.5em 0", paddingBottom: "1em" }}>
                        <div className="branches">
                          <div style={{ padding: "1em" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div
                                className="branchImg"
                                style={{ backgroundImage: `url(${data.image?.original ?? logoRemoved})` }}
                              ></div>
                              <div
                                className="branchDetails"
                                style={i18n.language == "ar" ? { marginRight: "1em" } : { marginLeft: "1em" }}
                              >
                                <p className="branchName">{data.name}</p>
                                <p className={data.is_active ? "branchState" : "branchState branchStateClosed"}>
                                  {data.is_active ? t("branches.open") : t("branches.Closed")}
                                </p>
                              </div>
                            </div>
                            <p className="branchPosition">
                              <span style={i18n.language == "ar" ? { marginLeft: "0.5em" } : { marginRight: "0.5em" }}>
                                <HiOutlineLocationMarker size={30} />
                              </span>
                              {data.address}
                            </p>
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <div className="menubottom">
                              <button
                                onClick={() => handleBranchesId(data.id)}
                                style={{ height: "65px" }}
                                className={i18n.language == "en" ? "enArrow-button2 arrow-button2" : "arrow-button2"}
                              >
                                {t("branches.choose")}
                                <span className="arrow2"></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default FromBranch;











// import "../Styles/FromBranch.css";
// import Footer from "../Components/Footer";
// import { HiOutlineLocationMarker } from "react-icons/hi";
// import { Swiper, SwiperSlide } from "swiper/react";
// import logo from "../Images/Login/logo.svg";
// // Import Swiper styles
// import { Link } from "react-router-dom";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import { Pagination, Navigation, Autoplay } from "swiper";
// import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
// import { IoIosArrowForward } from "react-icons/io";
// import { IoIosArrowBack } from "react-icons/io";
// import { useTranslation } from "react-i18next";
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { BeatLoader } from "react-spinners";
// import { near_branches, branchesByCity, carBranches_city } from "../api-nano";
// import ChangeType from "../Components/ChangeType";
// import {
//   countryCities,
//   countries,
//   departmentsByCity,
//   Clear_cart,
// } from "../api-nano";
// import com from "../Images/comm.png";
// import { MapContainer, Popup, TileLayer } from "react-leaflet";

// function FromBranch(props) {
//   const { isLoaded } = useLoadScript({
//     googleMapsApiKey: "AIzaSyDPInNXxJ-Drq0RXS45apFP3snnhX5VTpw",
//     libraries: ["places"],
//   });
//   const { t, i18n } = useTranslation();
//   const [map, setMap] = useState(null);
//   const [city, setCity] = useState([]);
//   const [branch, setBranch] = useState(
//     JSON.parse(localStorage.getItem("nearBranches"))
//   );
//   const [changeCity, setChangeCity] = useState([]);
//   const [change, setChange] = useState(false);
//   const [cityVlaue, setCityValue] = useState();
//   const [noNear, setNoNear] = useState(false);
//   const [changeModal, setChangeModal] = useState(false);
//   const [title, setTitle] = useState();
//   let history = useNavigate();
//   const [loading, setLoading] = useState(true);

//   const [position, setPostion] = useState({
//     lat: "",
//     lng: "",
//   });

//   // if order type is car pick up ()=>
//   /*the branches are filtered according to carOption if true,
//      if there are near branches map position is then set to lng and lat of first branch
//      else if no near branches and no chosen city text is displayed instead of the map 
//      */
//   // if order type is not car pick up ()=>
//   /*if there are near branches map position is then set to lng and lat of first branch
//      else if no near branches and no chosen city text is displayed instead of the map 
//      */
//   //countries api call fetch cities and sets them according to current chosen country index (props.country)
//   useEffect(() => {
//     if (localStorage.getItem("typeId") == 2) {
//       setTitle("home.option-home");
//       setLoading(false);
//     } else {
//       setTitle("home.option-branch");
//     }

//     window.scrollTo(0, 0);
//     const nearBranches = JSON.parse(localStorage.getItem("nearBranches"));
//     console.log(nearBranches);
//     if (nearBranches) {
//       setBranch(nearBranches);
//       if (nearBranches.length !== 0) {
//         setPostion({
//           lat: parseInt(nearBranches[0]?.latitude),
//           lng: parseInt(nearBranches[0]?.longitude),
//         });
//       }
//     }

//     // countryCities(props.country).then((response) => {
//     //   console.log("the citites", response);
//     //   setCity(response.data?.data[0]?.states.data);
//     //   setLoading(false);
//     // });
//     if (localStorage.getItem("typeId") == 1) {
//       departmentsByCity().then((response) => {
//         localStorage.setItem(
//           "nearBranches",
//           JSON.stringify(response.data?.data)
//         );
//         // setChange(!change);
//         console.log("hklsdfjlksdjf", response.data?.data);
//         setBranch(response.data?.data);
//         setLoading(false);
//       });
//     }

//     // if (!JSON.parse(localStorage.getItem("nearBranches")).length > 0) {
//     //   setNoNear(true);
//     // }
//     console.log("the bbbbbbbb", nearBranches);
//   }, [change, props.country]);

//   //loading shown if map in not yet loaded
//   if (!isLoaded) {
//     return (
//       <div className="loader">
//         <BeatLoader color={"#ffc010"} loading={!isLoaded} size={30} />
//       </div>
//     );
//   }

//   /*when choosing a branch if user has already chosen another branch before and cart is not empty 
//      ChangeType modal is displayed for user to confirm clearing the cart */
//   //else chosen branch id is stored and user is redirected to /menu (MainMenu component found in /Pages)
//   function chooseBranch(id) {
//     const token = localStorage.getItem("token");
//     let branchId = localStorage.getItem("branchId");

//     if (token && props.cartItems !== 0 && branchId && branchId !== id) {
//       setChangeModal(true);
//     } else {
//       localStorage.setItem("branchId", id);
//       history("/menu");
//     }
//   }

//   //on confirming clearing cart (from ChangeType modal)
//   //user cart is cleared
//   function handleClear() {
//     setLoading(true);

//     const token = window.localStorage.getItem("token");

//     Clear_cart(token)
//       .then((response) => {
//         localStorage.removeItem("promo"); //was used to store data that user entered in cart
//         localStorage.removeItem("paymentMethod"); //was used to store data that user entered in cart
//         localStorage.removeItem("cardToken");

//         //data stored in cartProcess2
//         localStorage.removeItem("timeNow");
//         localStorage.removeItem("cartMessage");
//         localStorage.removeItem("orderDate");
//         localStorage.removeItem("deliveryType");

//         localStorage.setItem("process", 0); //was used to store user's current step in cart, set to 0 to begin steps from the start
//         props.setCartChange(!props.cartChange); //triggers api call in (App.js) to rerender cart
//         setLoading(false);
//       })
//       .catch((error) => {});
//   }

//   //on changing city depending on order type different apis are called
//   //each take the selected city id and return a set of branches
//   function handleChange(e) {
//     setCityValue(e.target.value);
//     localStorage.getItem("typeId");

//     if (
//       localStorage.getItem("typeId") == 1 ||
//       localStorage.getItem("typeId") == 2
//     ) {
//       departmentsByCity().then((response) => {
//         localStorage.setItem(
//           "nearBranches",
//           JSON.stringify(response.data?.data)
//         );
//         console.log("the branch is", response.data?.data);
//         setChange(!change);
//       });
//     }
//     setNoNear(false);
//   }

//   return (
//     <div>
//       {" "}
//       {loading ? (
//         <div className="loader">
//           <BeatLoader color={"#ffc010"} loading={loading} size={30} />
//         </div>
//       ) : (
//         <div>
//           {" "}
//           {changeModal ? (
//             <ChangeType
//               text="change_branch"
//               handleClear={handleClear}
//               setModal={setChangeModal}
//             />
//           ) : null}
//           <div className="Address">
//             <div className="addressNav branchesPick container-fluid fluid">
//               <p>
//                 <Link to="/"> {t("address.home")} </Link>

//                 {i18n.language == "ar" ? (
//                   <IoIosArrowBack
//                     style={{
//                       color: "#4F4F4F",
//                     }}
//                   />
//                 ) : (
//                   <IoIosArrowForward style={{ color: "#4F4F4F" }} />
//                 )}

//                 <span> {t(title)} </span>
//               </p>{" "}
//               {/* {changeCity ? (
//                 <select defaultValue={""} onChange={(e) => handleChange(e)}>
//                   <option value="" disabled>
//                     {" "}
//                     {t("branches.city")}{" "}
//                   </option>
//                   {city &&
//                     city.map((data, index) => (
//                       <option key={index} value={data.id}>
//                         {" "}
//                         {data.name}{" "}
//                       </option>
//                     ))}{" "}
//                 </select>
//               ) : null} */}
//             </div>{" "}
//             {noNear ? (
//               <div className="container-fluid fluid chooseCity">
//                 <div className="noCity">
//                   <div>
//                     <p className="noNear"> {t("branches.no_near")} </p>{" "}
//                     <p className="choose"> {t("branches.chooseCity")} </p>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <div className="mapMargin">
//                 {/* Todo: Change Map from GoogleMap to React Leaflet  */}

//                 <GoogleMap
//                   zoom={9}
//                   center={{
//                     lat: position.lat,
//                     lng: position.lng,
//                   }}
//                   mapContainerClassName="branchMap"
//                   onLoad={(map) => setMap(map)}
//                   options={{
//                     mapTypeControl: false,
//                     streetViewControl: false,
//                   }}
//                 >
//                   {
//                     branch.map((data, index) => (
//                       <Marker
//                         key={index}
//                         icon={logo}
//                         position={{
//                           lat: parseInt(data.latitude),
//                           lng: parseInt(data.longitude),
//                         }}
//                       />
//                     ))}
//                 </GoogleMap>{" "}
//                 {/* <div className="branchMap"></div> */}
//                 <div className="branchesSlider">
//                   <div className="verticalAlign">
//                     {branch.length !== 0 ? (
//                       <Swiper
//                         navigation={true}
//                         dir={i18n.language == "ar" ? "rtl" : "ltr"}
//                         spaceBetween={10}
//                         key={i18n.language}
//                         breakpoints={{
//                           530: {
//                             slidesPerView: 1,
//                             spaceBetween: 20,
//                           },
//                           730: {
//                             slidesPerView: 2,
//                             spaceBetween: 20,
//                           },
//                           1160: {
//                             slidesPerView: 3,
//                             spaceBetween: 20,
//                           },
//                         }}
//                         modules={[Navigation]}
//                         className={
//                           i18n.language == "ar"
//                             ? "myCarousel branchesCrsl btnAr"
//                             : "myCarousel branchesCrsl btnEn"
//                         }
//                       >
//                         {branch &&
//                           branch?.map((data, index) => (
//                             <SwiperSlide
//                               key={index}
//                               // style={

//                               //     ? {
//                               //         display: "none",
//                               //       }
//                               //     : null
//                               // }
//                             >
//                               <div
//                                 style={{
//                                   margin: "0.5em 0",
//                                   paddingBottom: "1em",
//                                 }}
//                               >
//                                 <div className=" branches">
//                                   <div
//                                     style={{
//                                       padding: "1em",
//                                     }}
//                                   >
//                                     <div
//                                       style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                       }}
//                                     >
//                                       <div
//                                         className="branchImg"
//                                         style={{
//                                           backgroundImage: `url(${
//                                             data.image?.original ?? com
//                                           })`,
//                                         }}
//                                       >
//                                         {" "}
//                                       </div>
//                                       <div
//                                         className="branchDetails"
//                                         style={
//                                           i18n.language == "ar"
//                                             ? {
//                                                 marginRight: "1em",
//                                                 marginLeft: "0",
//                                               }
//                                             : {
//                                                 marginLeft: "1em",
//                                                 marginRight: "0",
//                                               }
//                                         }
//                                       >
//                                         <p className="branchName">
//                                           {" "}
//                                           {data.name}{" "}
//                                         </p>
//                                         <p
//                                           className={
//                                             data.is_active
//                                               ? "branchState"
//                                               : " branchState branchStateClosed"
//                                           }
//                                         >
//                                           {" "}
//                                           {data.is_active
//                                             ? t("branches.open")
//                                             : t("branches.Closed")}{" "}
//                                         </p>{" "}
//                                         <p className="branchTime">
//                                           {" "}
//                                           {/* {data.workingFrom} - {data.workingTo}{" "} */}
//                                         </p>{" "}
//                                       </div>
//                                     </div>
//                                     <p className="branchPosition">
//                                       {" "}
//                                       <span
//                                         style={
//                                           i18n.language == "ar"
//                                             ? {
//                                                 marginLeft: "0.5em",
//                                               }
//                                             : {
//                                                 marginRight: "0.5em",
//                                               }
//                                         }
//                                       >
//                                         {" "}
//                                         <HiOutlineLocationMarker size={30} />
//                                       </span>{" "}
//                                       {data.address}{" "}
//                                     </p>{" "}
//                                   </div>

//                                   <div
//                                     style={{
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     <div className="menubottom">
//                                       <button
//                                         onClick={() => chooseBranch(data.id)}
//                                         style={{
//                                           height: "65px",
//                                         }}
//                                         className={
//                                           i18n.language == "en"
//                                             ? "enArrow-button2 arrow-button2"
//                                             : "arrow-button2"
//                                         }
//                                       >
//                                         {" "}
//                                         {t("branches.choose")}{" "}
//                                         <span className="arrow2"> </span>{" "}
//                                       </button>
//                                     </div>{" "}
//                                   </div>
//                                 </div>{" "}
//                               </div>
//                             </SwiperSlide>
//                           ))}
//                       </Swiper>
//                     ) : null}

//                     {/*branch.length==0?
//                                          <div className="noBranch">
//                                          <div style={{backgroundImage:`url(${no})`}}></div>
//                                          <p>{t("branches.no_near")}</p>

                                          
//                                               </div> :null */}
//                   </div>
//                 </div>
//               </div>
//             )}{" "}
//           </div>{" "}
//           <Footer />
//         </div>
//       )}{" "}
//     </div>
//   );
// }

// export default FromBranch;
